import { type ResultOf } from '@graphql-typed-document-node/core'
import { atomWithReset } from 'jotai/utils'
import { focusAtom } from 'jotai-optics'

import { graphql } from '~/gql'
import {
  type Brand,
  type CustomerAttribute,
  type Question,
} from '~/hooks/useSurveyQuery'

export const isTabulationReadyAtom = atomWithReset(false)
export const isPendingTabulationAtom = atomWithReset(false)

const tabulationQueryDataFragment = graphql(`
  fragment CustomerAttributeAnalysisPage_TabulationQueryData on CountBySingleCustomerAttributeResult {
    byCustomerAttributeId
    result {
      brands {
        brandGroupId
        brandNumber
        result {
          count
          segmentNumber
        }
      }
      questions {
        questionId
        result {
          answers {
            answerOption {
              option
              text
            }
            count
          }
          questionId
        }
      }
      customerAttributes {
        customerAttributeId
        count
      }
      totalCount
    }
  }
`)

type TabulatedData = {
  result: ResultOf<typeof tabulationQueryDataFragment>[] | undefined
  columnCustomerAttributeIds: CustomerAttribute['id'][]
  brandIds: Brand['id'][]
  questionIds: Question['question_id'][]
  customerAttributeIds: CustomerAttribute['id'][]
}

export const tabulationDataAtom = atomWithReset<TabulatedData>({
  result: undefined,
  columnCustomerAttributeIds: [],
  brandIds: [],
  questionIds: [],
  customerAttributeIds: [],
})

export const tabulationResultAtom = focusAtom(tabulationDataAtom, (optic) =>
  optic.prop('result'),
)
export const tabulatedColumnCustomerAttributeIdsAtom = focusAtom(
  tabulationDataAtom,
  (optic) => optic.prop('columnCustomerAttributeIds'),
)
export const tabulatedBrandIdsAtom = focusAtom(tabulationDataAtom, (optic) =>
  optic.prop('brandIds'),
)
export const tabulatedQuestionIdsAtom = focusAtom(tabulationDataAtom, (optic) =>
  optic.prop('questionIds'),
)
export const tabulatedCustomerAttributeIdsAtom = focusAtom(
  tabulationDataAtom,
  (optic) => optic.prop('customerAttributeIds'),
)
